/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_No_Scraped_JobsInputs */

const en_jobs_no_scraped_jobs = /** @type {(inputs: Jobs_No_Scraped_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No scraped jobs yet.`)
};

const de_jobs_no_scraped_jobs = /** @type {(inputs: Jobs_No_Scraped_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine gescrapten Stellen.`)
};

const fr_jobs_no_scraped_jobs = /** @type {(inputs: Jobs_No_Scraped_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun emploi récupéré pour le moment.`)
};

const es_jobs_no_scraped_jobs = /** @type {(inputs: Jobs_No_Scraped_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay empleos recopilados.`)
};

const it_jobs_no_scraped_jobs = /** @type {(inputs: Jobs_No_Scraped_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun lavoro trovato ancora.`)
};

const nl_jobs_no_scraped_jobs = /** @type {(inputs: Jobs_No_Scraped_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen gevonden banen.`)
};

const pl_jobs_no_scraped_jobs = /** @type {(inputs: Jobs_No_Scraped_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak znalezionych ofert pracy.`)
};

const fi_jobs_no_scraped_jobs = /** @type {(inputs: Jobs_No_Scraped_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei vielä haettuja työpaikkoja.`)
};

const da_jobs_no_scraped_jobs = /** @type {(inputs: Jobs_No_Scraped_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen skrabede job endnu.`)
};

const sv_jobs_no_scraped_jobs = /** @type {(inputs: Jobs_No_Scraped_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga skrapade jobb ännu.`)
};

/**
* | output |
* | --- |
* | "No scraped jobs yet." |
*
* @param {Jobs_No_Scraped_JobsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_no_scraped_jobs = /** @type {((inputs?: Jobs_No_Scraped_JobsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_No_Scraped_JobsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_no_scraped_jobs(inputs)
	if (locale === "fr") return fr_jobs_no_scraped_jobs(inputs)
	if (locale === "es") return es_jobs_no_scraped_jobs(inputs)
	if (locale === "it") return it_jobs_no_scraped_jobs(inputs)
	if (locale === "nl") return nl_jobs_no_scraped_jobs(inputs)
	if (locale === "pl") return pl_jobs_no_scraped_jobs(inputs)
	if (locale === "fi") return fi_jobs_no_scraped_jobs(inputs)
	if (locale === "da") return da_jobs_no_scraped_jobs(inputs)
	if (locale === "sv") return sv_jobs_no_scraped_jobs(inputs)
	return en_jobs_no_scraped_jobs(inputs)
});